module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-01.b6a2092f.svg";